import { ReactNode } from 'react';
import * as React from 'react';
import { FieldValues, Path, UseFormReturn } from 'react-hook-form';

import { TextField } from '@/components/form/text-field';

interface CustomPasswordFieldProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  disabled: boolean;
  name: Path<T>;
  label: string;
  rightLabel?: ReactNode;
  autoComplete?: string;
}

type PasswordFieldProps<T extends FieldValues> = CustomPasswordFieldProps<T> &
  Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    keyof CustomPasswordFieldProps<T>
  >;

export function PasswordField<T extends FieldValues>({
  form,
  disabled,
  name,
  label,
  rightLabel,
  autoComplete,
}: PasswordFieldProps<T>) {
  return (
    <TextField
      form={form}
      disabled={disabled}
      name={name}
      label={label}
      rightLabel={rightLabel}
      autoComplete={autoComplete}
      type="password"
    />
  );
}
